require('./ie11');

require('core-js/features/map');

require('core-js/features/set');

require('raf').polyfill();